import { render } from "./ClientDetails.vue?vue&type=template&id=3b158e3f&scoped=true&ts=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"

import "./ClientDetails.vue?vue&type=style&index=0&id=3b158e3f&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b158e3f"]])

export default __exports__